import Image from 'next/image';

const AmbassadorPerks = () => {
  const PerkText = ({ text, alignRight = false, showCheck = true }) => (
    <div
      className={`perk-item py-4 ${
        alignRight
          ? 'text-right justify-content-end'
          : 'text-left justify-content-start'
      } d-flex`}
    >
      {!alignRight && showCheck && (
        <Image src="/images/ambassador/check.svg" height="18" width="18" />
      )}
      <div className="px-3 pb-2 perk-desc">{text}</div>
      {alignRight && showCheck && (
        <Image src="/images/ambassador/check.svg" height="18" width="18" />
      )}
    </div>
  );

  const PerkIcon = ({ name }) => (
    <div className="py-2 perk-icon">
      <Image src={`/images/ambassador/${name}.svg`} height="60" width="60" />
    </div>
  );

  const MobileViewPerksList = ({ icon, perkIndex }) => (
    <div className="d-flex flex-row">
      <img src={`/images/ambassador/${icon}.svg`} height="60" width="60" />
      <PerkText text={modifiedPerks[perkIndex]} showCheck={false} />
    </div>
  );

  return (
    <div id="ambassador-perks" className="mt-5">
      <div className="custom-container">
        <h1>
          As a Learnsic College Ambassador, you'll receive exclusive perks and
          benefits:
        </h1>

        <div className="flex-row d-lg-flex d-none d-md-flex justify-content-between mt-5">
          <div>
            <PerkText text={modifiedPerks[0]} alignRight={true} />
            <PerkText text={modifiedPerks[1]} alignRight={true} />
            <PerkText text={modifiedPerks[2]} alignRight={true} />
          </div>

          <div className="d-flex icon-col justify-content-center mx-5">
            {/* <div className="vertical-shadow-left"></div> */}
            <div className="perks-col d-flex justify-content-around flex-column">
              <PerkIcon name="leadership" />
              <PerkIcon name="invite" />
              <PerkIcon name="courselibrary" />
            </div>
            <div className="perks-col d-flex justify-content-around flex-column">
              <PerkIcon name="newfeatures" />
              <PerkIcon name="incentives" />
              <PerkIcon name="workshop" />
            </div>
            {/* <div className="vertical-shadow-right" /> */}
          </div>

          <div>
            <PerkText text={modifiedPerks[3]} />
            <PerkText text={modifiedPerks[4]} />
            <PerkText text={modifiedPerks[5]} />
          </div>
        </div>

        <div className="d-lg-none d-md-none d-block">
          <MobileViewPerksList icon="leadership" perkIndex={0} />
          <MobileViewPerksList icon="invite" perkIndex={1} />
          <MobileViewPerksList icon="courselibrary" perkIndex={2} />
          <MobileViewPerksList icon="newfeatures" perkIndex={3} />
          <MobileViewPerksList icon="incentives" perkIndex={4} />
          <MobileViewPerksList icon="workshop" perkIndex={5} />
        </div>
      </div>
    </div>
  );
};

export default AmbassadorPerks;

const perksList = [
  "Showcase your leadership role on Learnsic's platform as Ambassador.",
  'Invite students to join Learnsic and be a part of this dynamic community.',
  'Enhance your skills with complimentary access to our extensive course library.',
  "Be among the first to experience new features before they're released to the public.",
  'Participate in engaging learnsic workshops to enhance your skills and knowledge.',
  'Earn rewards such as cash incentives, exclusive merchandise.',
];

const modifiedPerks = [
  "Leadership role as Ambassador on Learnsic's platform",
  'Invite students to join Learnsic and be a part of this dynamic community',
  'Access to extensive course library for skill enhancement',
  'Early access to new features',
  'Earn rewards such as cash incentives, exclusive merchandise',
  'Participation in engaging learnsic workshops',
];